import styled from '@emotion/styled';

export const Container = styled.ul(({ theme }) => ({
    display: 'flex',
    gap: theme.space[1],
    flexDirection: 'row',
    listStyle: 'none',
    marginBottom: theme.space[6],
}));
